module.exports = __webpack_public_path__ + "img/Buscador-de-Formatos-para-Servidores.e49fc51f.svg";